import { Card, Stack, Typography } from "@altimateai/lego";
import CostBreakdown from "./CostBreakdown";
import SavingsBreakdown from "./SavingsBreakdown";
import { DateRange } from "../../../components/dateRange";
import { useSummaryDispatch } from "../SummaryNew";
import useSummaryState from "../useSummaryState";
import { setCurrentEndDate, setCurrentStartDate } from "../context/summarySlice";
import classes from "../summary.module.scss";
import { useAppState } from "@/modules/app/useAppContext";
import {
  DatabricksCostPastView,
  DatabricksSavingsSection,
} from "@/pages/databricks/summary/components";

const PastAnalysis = () => {
  const dispatch = useSummaryDispatch();
  const { currentStartDate, currentEndDate } = useSummaryState();
  const { isDatabricksTenant } = useAppState();

  const caption = isDatabricksTenant
    ? "This section shows your Databricks costs and usage for the selected period. Explore cost breakdowns by SKU type, workspace, and view trends over time."
    : "This section shows you costs and savings occurred in your Snowflake environment during the selected time period";

  return (
    <Card className={classes.past_analysis} id="tour-past-analysis">
      <Stack className="al-justify-between mb-2" id="current">
        <Typography variant="section-heading">Current State</Typography>
        <DateRange
          startDate={currentStartDate}
          endDate={currentEndDate}
          onDateRangeSelect={(startDate, endDate) => {
            dispatch(setCurrentStartDate(startDate));
            dispatch(setCurrentEndDate(endDate));
          }}
          id="past-date-range"
          maxDate={new Date()}
        />
      </Stack>
      <p className={classes.caption}>{caption}</p>
      {isDatabricksTenant ? (
        <>
          <DatabricksCostPastView startDate={currentStartDate} endDate={currentEndDate} />
          <DatabricksSavingsSection
            isFuture={false}
            startDate={currentStartDate}
            endDate={currentEndDate}
          />
        </>
      ) : (
        <>
          <CostBreakdown currentEndDate={currentEndDate} currentStartDate={currentStartDate} />
          <SavingsBreakdown currentEndDate={currentEndDate} currentStartDate={currentStartDate} />
        </>
      )}
      <div id="future" />
    </Card>
  );
};

export default PastAnalysis;
